import moment from "moment";

export function readablePeriod(period = []) {
  return period.map(p => moment(p).format("DD [de] MMMM YYYY")).join(" – ");
}
